import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Container from "@/components/base/Container";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "事件盘点", to: "/topics" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "bg-gradient-to-b from-foreground-950/75 via-foreground-950/35 to-transparent"
      }`}
    >
      <Container>
        <div className="flex h-16 items-center justify-between gap-4 md:h-[74px]">
          <Link to="/" className="flex cursor-pointer items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-newspaper-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-[17px] font-bold tracking-wide ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                瓜田速报
              </span>
              <span
                className={`mt-1 text-[10px] tracking-[0.22em] ${
                  solid ? "text-foreground-400" : "text-background-200/80"
                }`}
              >
                MAYDAY REPORT
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? solid
                        ? "bg-primary-100 text-primary-700"
                        : "bg-background-50/20 text-background-50"
                      : solid
                        ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                        : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/contact#subscribe"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              订阅速报
            </Link>
            <button
              type="button"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border transition-colors md:hidden ${
                solid
                  ? "border-background-300 text-foreground-900 hover:bg-background-100"
                  : "border-background-50/30 text-background-50"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </Container>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <Container>
            <nav className="flex flex-col py-2" aria-label="移动端导航">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium ${
                      isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700"
                    }`
                  }
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line" />
                </NavLink>
              ))}
              <Link
                to="/contact#subscribe"
                className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3 py-3 text-sm font-medium text-background-50"
              >
                <i className="ri-mail-send-line" />
                订阅速报
              </Link>
            </nav>
          </Container>
        </div>
      )}
    </header>
  );
}